<mat-toolbar color="primary">
    <span>Carte d'identité</span>
</mat-toolbar>
<mat-dialog-content>
    <div>
        <mat-form-field class="">
          <mat-label>Nom</mat-label>
          <input disabled="true" class="" type="text" [ngModel]="eiddata.surname" name="surname" matInput placeholder="Nom de famille">
          <!-- <mat-hint class="hint-alert" *ngIf="dmg.lastName != patient.patient.getProperty('Lastname')">{{ patient.patient.getProperty('Lastname') }}</mat-hint> -->
        </mat-form-field>
        <mat-form-field class="">
          <mat-label>Prénom(s)</mat-label>
          <input disabled="true" class="" type="text" [ngModel]="eiddata.firstnames" name="firstnames" matInput placeholder="Prénom(s)">
          <!-- <mat-hint class="hint-alert" *ngIf="dmg.firstName != patient.patient.getProperty('Firstname')">{{ patient.patient.getProperty('Firstname') }}</mat-hint> -->
        </mat-form-field>
    </div>
    <div>
        <mat-form-field class="">
          <mat-label>Genre</mat-label>
          <input disabled="true" class="" type="text" [ngModel]="eiddata.gender" name="gender" matInput placeholder="Genre">
          <!-- <mat-hint class="hint-alert" *ngIf="dmg.lastName != patient.patient.getProperty('Lastname')">{{ patient.patient.getProperty('Lastname') }}</mat-hint> -->
        </mat-form-field>
        <mat-form-field class="">
          <mat-label>NISS</mat-label>
          <input disabled="true" class="" type="text" [ngModel]="eiddata.national_number" name="national_number" matInput placeholder="NISS">
          <!-- <mat-hint class="hint-alert" *ngIf="dmg.firstName != patient.patient.getProperty('Firstname')">{{ patient.patient.getProperty('Firstname') }}</mat-hint> -->
        </mat-form-field>
    </div>  
    <div>
        <mat-form-field class="">
          <mat-label>Date de naissance</mat-label>
          <input disabled="true" class="" type="text" [ngModel]="eiddata.date_of_birth" name="date_of_birth" matInput placeholder="Date de naissance">
          <!-- <mat-hint class="hint-alert" *ngIf="dmg.lastName != patient.patient.getProperty('Lastname')">{{ patient.patient.getProperty('Lastname') }}</mat-hint> -->
        </mat-form-field>
        <mat-form-field class="">
          <mat-label>Lieu de naissance</mat-label>
          <input disabled="true" class="" type="text" [ngModel]="eiddata.location_of_birth" name="location_of_birth" matInput placeholder="Lieu de naissance">
          <!-- <mat-hint class="hint-alert" *ngIf="dmg.firstName != patient.patient.getProperty('Firstname')">{{ patient.patient.getProperty('Firstname') }}</mat-hint> -->
        </mat-form-field>
    </div> 
    <div *ngIf="displaySearch">

    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn btn-danger">Fermer</button>
    <button mat-button mat-dialog-close class="btn btn-success" (click)="updatePatient()">Mettre à jour</button>
</mat-dialog-actions>
